export default __webpack_public_path__ + "static/media/landing-users.0814b614.png";